<template>
    <div class="component">
        <div class="main-title">
            <div class="square"></div>
            <div class="title-content">求职意向</div>
        </div>
        <div class="main-content">
            <portrait-labels :labelList="componentData"></portrait-labels>
        </div>
    </div>

</template>

<script>
    export default {
        name: "TabJob",
        props: {
            componentData: [Object, Array]
        },
        data() {
            return {}
        },
        mounted() {
            console.log(this.componentData)
        },
        methods: {},
    }
</script>

<style lang="less">

</style>

